import { Injectable, EventEmitter } from '@angular/core';
import { IDocumentoDto } from '../../nucleo/interface/dto/IDocumentoDto';
import { IModalGenerico } from '../../nucleo/interface/form/IModalGenerico';
import { AutenticacionService } from '../../seguridad/autenticacion.service';
import { ServicioService } from '../../servicio/servicio.service';
import { ModalImagenComponent } from './modal-imagen.component';


@Injectable({
  providedIn: 'root'
})

export class ModalImagenService {
  public titulo: string;
  public oculto: string = 'ocultar-modal';
  public documento : IDocumentoDto;
  public notificacion = new EventEmitter<IModalGenerico>();
  private modalImagemComponente : ModalImagenComponent;
 
  constructor(public loginService: AutenticacionService,
    public service: ServicioService) { }
  

  registrarComponente(component : ModalImagenComponent){
    this.modalImagemComponente = component;
  }

  ocultarModal() {
    this.oculto = 'ocultar-modal';
    this.titulo = null;
  }

  mostrarModal( titulo: string, documento : IDocumentoDto) : Promise<IModalGenerico>{
    let promesa = new Promise<IModalGenerico>((resolve)=> {
      this.oculto = '';
      this.titulo = titulo; 
      this.documento = documento;
      this.modalImagemComponente.descargarDocumento();
      this.notificacion.subscribe( response => {
        resolve(response)
      })
    })

    return (promesa)
  }

}